
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeLifeboatFilled as ObiVesselTypeLifeboatFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-lifeboat-filled.js';
 
 
 

 
 export const ObiVesselTypeLifeboatFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-lifeboat-filled',
   elementClass: ObiVesselTypeLifeboatFilledElement,
   events: {
     
   }
  });
 
 